import { useTranslation } from 'react-i18next';
import EmptyCart from '../../../assets/images/empty_cart.png';
import { ShopType } from 'models';
import { useAppSelector } from 'hooks';
export interface BillDetailNoBillProps {
  billData: any;
}

export function BillDetailNoBill(props: BillDetailNoBillProps) {
  const { billData } = props;
  const { t } = useTranslation();
  const shopsHideSetMenu = [460, 462];
  const shopInfo: ShopType = useAppSelector((state) => state.shop.shopInfo);
  const checkShopShowNominationTimes = shopsHideSetMenu.includes(shopInfo?.id);
  const tableInfo = [
    {
      title: 'テーブル',
      content: billData?.name || '-',
    },
    {
      title: '日付',
      content: '-',
    },
    {
      title: '伝票コード',
      content: '-',
    },
    ...(checkShopShowNominationTimes
      ? [
          {
            title: '指名本数',
            content: '-',
          },
        ]
      : []),
  ];
  return (
    <div className="flex flex-1 flex-col bg-white">
      <div className="table-info w-full flex items-center py-3">
        {tableInfo.map((item, index) => (
          <div
            key={index}
            className={`${
              checkShopShowNominationTimes
                ? 'first:w-[18%] last:w-[18%] [&:nth-child(2)]:w-1/2 w-full'
                : 'w-1/3'
            } whitespace-nowrap text-center border-r last:border-r-0 border-border_primary px-2`}
          >
            <span className="text-[#939393]">{item.title}</span>
            <p className="!font-noto-sans-bold font-[500] text-brown_dark">{item.content}</p>
          </div>
        ))}
      </div>
      <div className="border-t border-border_primary">
        <h3 className="font-noto-sans-bold text-brown_dark text-base p-3">{t('ORDER_HISTORY')}</h3>
        <div className="w-full h-full">
          <table className="order-history-table w-full">
            <thead>
              <tr>
                <th>{t('MERCHANDISE')}</th>
                <th>{t('TIME')}</th>
                <th>{t('AMOUNT')}</th>
              </tr>
            </thead>
          </table>
          <div className="mt-[40px] flex flex-col items-center justify-center">
            <img src={EmptyCart} alt="" className="w-[100px] h-[100px] aspect-square" />
            <div className="mt-[17px] text-[#939393] text-base text-center">
              <p>{t('NO_PRODUCT')}</p>
              <p>{t('PLEASE_ORDER_THE_PRODUCT')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
